//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from 'react';

// === COMPONENTS ===
import { Select } from 'components/Select/index';

// === API ===
import {updateField} from "api/prokey/prokey.websocket";
import {validate} from './validation/index';
import {SUCCESS_CODE} from 'constants/general';

//#endregion

export { validate };

//-----------------------------------------------------------------
export function Selection( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  // const theme    = useTheme();

  const { id, field } = props;

  const [ content , setContent ] = useState( props.value );

  const cross_doc_content = field.DisplayInfo ? field.DisplayInfo.CrossDocContent || [] : [];

  const show_output = field.validationInfo.ShowAbbr;
  const values_default = Object.keys( field.validationInfo.OutputValues || {} ).map(output => {
    const display = field.validationInfo.OutputValues[output];
    return { label: show_output ? `${output}:${display}` : display, value: output };
  });
  const values_cross_doc = cross_doc_content.map( x => { return { label: x, value: x } } );
  const items = [...values_cross_doc, ...values_default]

  field.validationInfo.acceptableValues = Object.keys( field.validationInfo.OutputValues || {} );
  if( field.validationInfo.ForceAddNewSelectionValue ) {
    field.validationInfo.acceptableValues = [ ...cross_doc_content, ...field.validationInfo.acceptableValues];
  }
  const is_auto_mode = localStorage.getItem( 'auto-mode' ) === 'true';

  const US_STATES = {
    "ALABAMA": "AL", "ALASKA": "AK", "ARIZONA": "AZ", "ARKANSAS": "AR", "AMERICAN SAMOA": "AS",
    "CALIFORNIA":"CA", "COLORADO": "CO", "CONNECTICUT": "CT", "DELAWARE": "DE", "DISTRICT OF COLUMBIA": "DC",
    "FLORIDA":"FL", "GEORGIA": "GA", "GUAM" :"GU", "HAWAII": "HI", "FEDERATED STATES OF MICRONESIA": "FM",       
    "IDAHO": "ID", "ILLINOIS": "IL", "INDIANA": "IN", "IOWA": "IA", "KANSAS": "KS",
    "KENTUCKY": "KY", "LOUISIANA": "LA", "MAINE": "ME", "MARYLAND": "MD", "MARSHALL ISLANDS": "MH",
    "MASSACHUSETTS": "MA", "MICHIGAN": "MI", "MINNESOTA": "MN", "MISSISSIPPI": "MS", "MISSOURI": "MO",
    "MONTANA": "MT", "NEBRASKA": "NE", "NEVADA": "NV", "NEW HAMPSHIRE": "NH", "NEW JERSEY": "NJ",
    "NEW MEXICO": "NM", "NEW YORK": "NY", "NORTH CAROLINA": "NC", "NORTH DAKOTA": "ND", "NORTHERN MARIANA ISLANDS": "MP",
    "OHIO": "OH", "OKLAHOMA":  "OK", "OREGON": "OR", "PALAU": "PW", "PENNSYLVANIA": "PA",
    "PUERTO RICO": "PR", "RHODE ISLAND": "RI", "SOUTH CAROLINA": "SC", "SOUTH DAKOTA": "SD", "TENNESSEE": "TN",
    "TEXAS":  "TX", "UTAH": "UT", "VERMONT": "VT", "VIRGIN ISLANDS": "VI", "VIRGINIA": "VA",
    "WASHINGTON": "WA", "WEST VIRGINIA": "WV", "WISCONSIN": "WI", "WYOMING": "WY",
  }
        
  //#endregion
  
  //#region [STYLES]



  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    const display = field.validationInfo.OutputValues?.[props.value];
    const value = display ? display : props.value;
    setContent( value );
  }, [props.value] );

  //#endregion

  //#region [EVENTS] 

  //-----------------------------------------------------------------
  function onChange( event ) {
    //-----------------------------------------------------------------
    let value = event.target ? event.target.value.toUpperCase() : event.value.toUpperCase();

    if (event.isSubmit) {
      if (field.DisplayInfo.Type === 'us-state') {
        const state_abbr = US_STATES[value.toUpperCase()];
        if( state_abbr ) value = state_abbr;
      }
 
      const is_action_force = event.trigger === 'FORCED';
      const is_action_enter = event.trigger === 'ENTER';
      const is_action_tab   = event.trigger === 'TAB';
      props.confirm( {is_action_force, is_action_enter, is_action_tab}, value );
    }
  }

  //-----------------------------------------------------------------
  function onKeyDown( event ) {
    //-----------------------------------------------------------------
    try {
      if (typeof props.onKeyDown === 'function') {
        props.onKeyDown(event);
      }
    } catch (error) {
      console.warn(error);
    }
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Select
        name={props.name}
        id={id}
        inputStyle={props.style}
        options={items}
        value={content}
        forceSelected={true}
        innerRef={props.inputRef}
        has_focus={props.has_focus}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onBlur={props.onBlur}
        disabled={field.isReadOnly}
      />
    );
  }

  //#endregion

  return display();
}